import { sum } from 'lodash';

import { IPartInventoryItem } from 'parts/types';

export const sumQuantityAvailable = (records: IPartInventoryItem[]): number =>
  sum(records.map((record) => Number(record.quantityAvailable) || 0));
